

































import { Vue, Component } from 'vue-property-decorator';
import {
  Market, Sector, Settings, SettingsApi,
} from '@compassdigital/foodworks.ts.sdk';
import ConfigUtil from '@/util/ConfigUtil';
import SystemModule from '@/store/modules/system';
import ConfigurationType from '@/components/Form/Configuration/ConfigurationType/index.vue';
import AppModule from '@/store/modules/app';
import ActiveEvents from './activeEvents.vue';


@Component({
  components: {
    ConfigurationType,
    ActiveEvents,
  },
})
export default class Configuration extends Vue {
  public sectorsArray: Sector | null = null;

  public marketsArray: Market | null = null;

  public cuisinesArray: Settings [] = [];

  public error: string = '';

  public mounted() {
    this.getListItem();
  }

  public getListItem() {
    try {
      const { sectors, markets }: any = SystemModule;
      ((this.sectorsArray) as any) = ConfigUtil.filterSector(sectors);
      ((this.marketsArray) as any) = ConfigUtil.filterMarket(markets);
      this.getCuisinesArray();
    } catch (err) {
      this.error = err.error;
    }
  }

  public async getCuisinesArray() {
    const api = new SettingsApi(AppModule.apiConfig);
    const cuisine: any = await api.getSettings();
    const { cuisineTypes } = cuisine.data;
    const cuisinesArrays = cuisineTypes.sort((a:any, b:any) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
    this.cuisinesArray = cuisinesArrays;
  }
}
